 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"9eb76d8cb81210a3f461bf6596a15e8a453e6f26","1":"c05d59f0a486492baae3c6fb00dfb1f716c780d8","2":"styles","3":"9d81fc602c454f7d2663edd250037f1ed1ad465c","4":"2c8bce60ed1679a8e155738a80f34f4ec08e29b5","5":"aa2ffc8b44bc7761e5a106ad567904679e1fe932","6":"component---src-pages-dashboard-request-demo-js","10":"component---src-pages-404-js","11":"component---src-pages-about-index-js","12":"component---src-pages-callback-index-js","13":"component---src-pages-dashboard-index-js","14":"component---src-pages-eula-index-js","15":"component---src-pages-implementation-index-js","16":"component---src-pages-index-js","17":"component---src-pages-install-zoom-index-js","18":"component---src-pages-partners-reseller-js","19":"component---src-pages-platform-admission-js","20":"component---src-pages-platform-community-js","21":"component---src-pages-platform-index-js","22":"component---src-pages-platform-learning-management-system-js","23":"component---src-pages-platform-online-exams-js","24":"component---src-pages-platform-online-live-js","25":"component---src-pages-platform-school-management-js","26":"component---src-pages-platform-student-information-system-js","27":"component---src-pages-press-index-js","28":"component---src-pages-privacy-policy-index-js","29":"component---src-pages-release-notes-index-js","30":"component---src-pages-request-for-more-info-index-js","31":"component---src-pages-resources-index-js","32":"component---src-pages-resources-videos-index-js","33":"component---src-pages-services-index-js","34":"component---src-pages-solutions-college-and-university-js","35":"component---src-pages-solutions-high-school-js","36":"component---src-pages-solutions-middle-school-js","37":"component---src-pages-solutions-primary-school-js","38":"component---src-pages-solutions-test-center-js","39":"component---src-pages-solutions-training-institute-js","40":"component---src-pages-training-admin-index-js","41":"component---src-pages-training-en-admin-index-js","42":"component---src-pages-training-en-index-js","43":"component---src-pages-training-en-instructor-index-js","44":"component---src-pages-training-en-junior-index-js","45":"component---src-pages-training-en-parent-index-js","46":"component---src-pages-training-en-student-index-js","47":"component---src-pages-training-index-js","48":"component---src-pages-training-instructor-index-js","49":"component---src-pages-training-junior-index-js","50":"component---src-pages-training-parent-index-js","51":"component---src-pages-training-student-index-js","54":"reactPlayerDailyMotion","55":"reactPlayerFacebook","56":"reactPlayerFilePlayer","57":"reactPlayerKaltura","58":"reactPlayerMixcloud","59":"reactPlayerPreview","60":"reactPlayerSoundCloud","61":"reactPlayerStreamable","62":"reactPlayerTwitch","63":"reactPlayerVidyard","64":"reactPlayerVimeo","65":"reactPlayerWistia","66":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"f26492c49784e9a33594","1":"8c7862b38a4610988f0b","2":"2d82ac8e3afc0c213061","3":"1a9f707ef76d15f0998f","4":"e650ad70601a2dbca915","5":"4d1bcfc5a5b00e58a6bb","6":"0a1c361f0853f6d9e205","10":"49fd46e7c29d65e09362","11":"bdc5eb11e80cee4dcd19","12":"eb8654098c93a1d3771a","13":"560f4b25c2256e9d3c76","14":"e00f12eb9d61e6e9e35e","15":"6f902392f09c779903a0","16":"c94fe8c7b30975a5f691","17":"16f821eaf6f0c101a47a","18":"8373d698312a058c7a88","19":"a93b80c7b243a14f4cb0","20":"fa268a9f58b5b1ff9812","21":"0d021ba47a5609590e5b","22":"bc346f865e3d1b392442","23":"f21664edcfe9e1c21570","24":"ad4fedad705ef3d9d487","25":"44f58a6d893576cef245","26":"4764aa452e198b7d6ae8","27":"72d50c098f773b0b82e2","28":"9c778450aefbad42a8ad","29":"fc56a49370a1347fb76b","30":"a58a37ed109058ebdeeb","31":"5c536a2f8177f00cdf90","32":"d8fb07e02b1a794e9876","33":"df282042b32ea8736b97","34":"e10fe0f736ad0fcc60d4","35":"b8b0c7201a53a94a1438","36":"a8f9d7d4c83e20ef25d3","37":"47a9b97618d796cfb3a5","38":"18e34f8439aa8a1263f4","39":"f4c3fe47f97cfa604a7a","40":"43742ef74dab3afd7185","41":"2e26edc169d65c01d6f5","42":"33554b760cfbab71a6c9","43":"95303240a1ed92225910","44":"7264db063d117dc1c55b","45":"86d7982840b295d95fe3","46":"8e7e3f2951ebac3b6b77","47":"5ce895886a0a7149d73f","48":"e4e72b40d33885067571","49":"9bd1bbf90de4ddc58713","50":"88d43d49298fc579ae1d","51":"d3eb58355bcdfd6ec3b0","54":"33d19870fb3505773306","55":"e92a16dc02e9aed65919","56":"66b564e13d35e0ec1c21","57":"7d18d3750e9b6c51bf2c","58":"3f5973e09cff90ba3e5a","59":"7095ff9a7d1c084da6eb","60":"515fe88a48095ea506fd","61":"6d7dc3f28eaf40229360","62":"03abc70b92f0a02607e9","63":"2deeb4b6089c45fce201","64":"90e6a040640a61928be2","65":"b4fa6baaef268b62e094","66":"eb98d95d9e8b8d46448d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"9eb76d8cb81210a3f461bf6596a15e8a453e6f26","1":"c05d59f0a486492baae3c6fb00dfb1f716c780d8","2":"styles","3":"9d81fc602c454f7d2663edd250037f1ed1ad465c","4":"2c8bce60ed1679a8e155738a80f34f4ec08e29b5","5":"aa2ffc8b44bc7761e5a106ad567904679e1fe932","6":"component---src-pages-dashboard-request-demo-js","10":"component---src-pages-404-js","11":"component---src-pages-about-index-js","12":"component---src-pages-callback-index-js","13":"component---src-pages-dashboard-index-js","14":"component---src-pages-eula-index-js","15":"component---src-pages-implementation-index-js","16":"component---src-pages-index-js","17":"component---src-pages-install-zoom-index-js","18":"component---src-pages-partners-reseller-js","19":"component---src-pages-platform-admission-js","20":"component---src-pages-platform-community-js","21":"component---src-pages-platform-index-js","22":"component---src-pages-platform-learning-management-system-js","23":"component---src-pages-platform-online-exams-js","24":"component---src-pages-platform-online-live-js","25":"component---src-pages-platform-school-management-js","26":"component---src-pages-platform-student-information-system-js","27":"component---src-pages-press-index-js","28":"component---src-pages-privacy-policy-index-js","29":"component---src-pages-release-notes-index-js","30":"component---src-pages-request-for-more-info-index-js","31":"component---src-pages-resources-index-js","32":"component---src-pages-resources-videos-index-js","33":"component---src-pages-services-index-js","34":"component---src-pages-solutions-college-and-university-js","35":"component---src-pages-solutions-high-school-js","36":"component---src-pages-solutions-middle-school-js","37":"component---src-pages-solutions-primary-school-js","38":"component---src-pages-solutions-test-center-js","39":"component---src-pages-solutions-training-institute-js","40":"component---src-pages-training-admin-index-js","41":"component---src-pages-training-en-admin-index-js","42":"component---src-pages-training-en-index-js","43":"component---src-pages-training-en-instructor-index-js","44":"component---src-pages-training-en-junior-index-js","45":"component---src-pages-training-en-parent-index-js","46":"component---src-pages-training-en-student-index-js","47":"component---src-pages-training-index-js","48":"component---src-pages-training-instructor-index-js","49":"component---src-pages-training-junior-index-js","50":"component---src-pages-training-parent-index-js","51":"component---src-pages-training-student-index-js","54":"reactPlayerDailyMotion","55":"reactPlayerFacebook","56":"reactPlayerFilePlayer","57":"reactPlayerKaltura","58":"reactPlayerMixcloud","59":"reactPlayerPreview","60":"reactPlayerSoundCloud","61":"reactPlayerStreamable","62":"reactPlayerTwitch","63":"reactPlayerVidyard","64":"reactPlayerVimeo","65":"reactPlayerWistia","66":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"bade3ca38f5f7b15965c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
